import { formatNumber } from '../../../../utils';
import parseFormattedNumber from '../../../../utils/number/formatters/parseFormattedNumber';

type Props = {
  decimals: number | undefined;
  inputValue: string | number;
};

const getPreviewValue = ({
  inputValue,
  decimals,
}: Props): string | undefined => {
  const parsedNumber =
    typeof inputValue === 'number'
      ? inputValue
      : parseFormattedNumber(inputValue);

  return formatNumber(parsedNumber, {
    decimals,
  });
};

export default getPreviewValue;
